import { swapMealRecipeMutation } from '@akin-home/meals/frontend';
import { useMutation, useQueryClient } from 'react-query';
import { mealQueryKeys } from '.';

export const useSwapMealRecipe = () => {
  const query_client = useQueryClient();

  return useMutation(swapMealRecipeMutation, {
    onSuccess(data) {
      query_client.invalidateQueries(mealQueryKeys.lists());
      query_client.invalidateQueries(mealQueryKeys.detail(data.id));
    },
  });
};
